<div class="app-shell">
  <header class="top-nav" *ngIf="showShellNav()">
    <div class="page-shell nav-grid">
      <a routerLink="/problems" class="brand">
        <strong>javaStreams</strong>
        <small>Java Stream API Practice</small>
      </a>
      <nav>
        <a routerLink="/dashboard" routerLinkActive="active-link">Dashboard</a>
        <a routerLink="/problems" routerLinkActive="active-link">Problems</a>
        <a routerLink="/challenge/1" routerLinkActive="active-link">Workspace</a>
        <a routerLink="/leaderboard" routerLinkActive="active-link">Leaderboard</a>
        <a routerLink="/profile" routerLinkActive="active-link">Profile</a>
      </nav>
      <div class="user-area" *ngIf="user() as u">
        <span class="chip">Lv {{ u.level }}</span>
        <span class="chip">{{ u.xp }} XP</span>
        <button class="btn-secondary" (click)="toggleTheme()">
          {{ theme() === "dark" ? "Light" : "Dark" }}
        </button>
        <button class="btn-secondary" (click)="logout()">Logout</button>
      </div>
    </div>
  </header>
  <router-outlet></router-outlet>
</div>
